import { render } from "./zuoyiyouer.vue?vue&type=template&id=c353e3b4&scoped=true"
import script from "./zuoyiyouer.vue?vue&type=script&lang=js"
export * from "./zuoyiyouer.vue?vue&type=script&lang=js"

import "./zuoyiyouer.vue?vue&type=style&index=0&id=c353e3b4&scoped=true&lang=css"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c353e3b4"]])

export default __exports__